import axios from 'axios'
import React, { useState } from 'react'
import Swal from 'sweetalert2'
import Spinner from '../Spinner';
import { Inertia } from '@inertiajs/inertia';

const RemoveExportButton = ({ id }) => {
    const [loading, setLoading] = useState(false);

    const handleRemove = async () => {
        if (loading) return;

        Swal.fire({
            title: '¿Estas seguro de querer eliminar este reporte?',
            text: "Esta acción no se puede revertir",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar',
            cancelButtonText: 'Cancelar'
        }).then(({ isConfirmed }) => {
            if (isConfirmed) {
                try {
                    setLoading(true)
                    axios.delete(route('export.request.delete', id))
                        .then(() => {
                            Swal.fire(
                                '¡Eliminado!',
                                'El reporte ha sido eliminado.',
                                'success'
                            )
                            setLoading(false)
                            Inertia.reload({ only: ['exportRequests'] })
                        })
                        .catch(() => {
                            Swal.fire(
                                '¡Error!',
                                'El reporte no ha podido ser eliminado.',
                                'error'
                            )
                            setLoading(false)
                        })
                } catch (error) {
                    Swal.fire(
                        '¡Error!',
                        'El reporte no ha podido ser eliminado.',
                        'error'
                    )
                    setLoading(false)
                }
            }
        })
    }

    return (
        <button style={{ padding: 11 }} className="bg-red-400 fill-white rounded-md" onClick={handleRemove}>
            {loading ? <Spinner width="1rem" height="1rem" weight={2} color="transparent" backgroundColor="#ffffff" /> : (
                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg>
            )}
        </button>
    )
}

export default RemoveExportButton